module.exports = __webpack_public_path__ + "media/assets/icons/delete-7f16b305abfaab7c7f27dfac0af54507.svg";